import { useLazyQuery } from '@apollo/client';
import { QUERY_DOG_RESCUES_TESTIMONIALS } from '../../graphql/dog-queries';

export default function useGetDogRescueTesti() {
    const [getDogRescueTesti, { data, loading }] = useLazyQuery(QUERY_DOG_RESCUES_TESTIMONIALS);
    return { getDogRescueTesti, data: data?.dogRescuePage?.testimonials, loading };
}
